const centerQrcodeRoutes = [
  {
    path: '/center-qrcode/my-qrcode',
    name: 'my-qrcode',
    component: () => import('@/views/center-qrcode/my-qrcode'),
    meta: {
      needLogin: true
    }
  }
]

export default centerQrcodeRoutes
